import { apiProxyRequest } from "Api/apiProxyRequest";

import type { ApiToken } from "./types";

type AddApiTokenRequestProps = {
  userId: string;
  name: string;
};
export const addApiTokenRequest = ({ userId, name }: AddApiTokenRequestProps) =>
  apiProxyRequest<ApiToken>(`/users/${userId}/api-tokens`, "POST", { name });
